module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaArquivos,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui arquivos.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + 'projetos/' + _vm.idProjeto + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("fa fa-fw fa-download")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n      ")], 1)]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaArquivos.length) + " arquivos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toUploadArquivo
    }
  }, [_vm._v("Adicionar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9a18c6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/projeto-editar-arquivos.vue
// module id = 550
// module chunks = 0